import React from "react";

import { DefaultWidgetMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { ActionContentboxProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox";

import { getViewHtmlId } from "../modules/focusHandling/sagas";

import { ActivityIdContext } from "./ActivityContext";

export const CustomActionContentbox: React.ComponentType<ActionContentboxProps> = function CustomActionContentbox(
	props
) {
	const activityId = React.useContext(ActivityIdContext);
	return <DefaultWidgetMap.ActionContentbox {...props} padding="0px 40px 40px" id={getViewHtmlId(activityId)} />;
};
